module.exports = __webpack_public_path__ + "img/partner03.a9bcfeb3.png";